import { api, resolveAuthenticatedAssetUrl } from '@/utils/request'
import { setAuth, clearAuth, getStaff, getMenus } from '@/utils/auth'

const state = {
    staff: getStaff(),
    menus: getMenus(),
}

const mutations = {
    SET_USER_INFO(state, payload) {
        state.staff = (payload && payload.staff) || null
        state.menus = (payload && payload.menus) || []
    },
    CLEAR_USER_INFO(state) {
        state.staff = null
        state.menus = []
    },
}

const actions = {
    setUserInfo({ commit }, payload) {
        const userInfo = payload || {}
        commit('SET_USER_INFO', userInfo)
        setAuth(userInfo)
        return userInfo
    },
    fetchUserInfo({ dispatch }) {
        return api('/trade/auth/me', 'post').then((res) => {
            if (!res || res.code !== 200) {
                return Promise.reject(res || { msg: '获取用户信息失败' })
            }

            return dispatch('setUserInfo', res.data || {})
        })
    },
    clearUserInfo({ commit }) {
        commit('CLEAR_USER_INFO')
        clearAuth()
    },
}

const getters = {
    staff: (state) => state.staff || {},
    menus: (state) => state.menus || [],
    staffName: (state) => {
        const staff = state.staff || {}
        return staff.name || staff.username || ''
    },
    departmentName: (state) => {
        const staff = state.staff || {}
        return staff.department_name || ''
    },
    staffAvatar: (state) => {
        const staff = state.staff || {}
        return resolveAuthenticatedAssetUrl(staff.avatar)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
